module.exports = __webpack_public_path__ + "images/11.png";